import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box } from "@mui/material";
import Table from '@mui/material/Table';
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
const dateData = [
    { week: 'Week 1', dateRange: '19-09-2025 to 21-09-2025' },
    { week: 'Week 2', dateRange: '22-09-2025 to 28-09-2025' },
    { week: 'Week 3', dateRange: '29-09-2025 to 05-10-2025' },
    { week: 'Week 4', dateRange: '06-10-2025 to 12-10-2025' },
    { week: 'Week 5', dateRange: '13-10-2025 to 19-10-2025' },
    { week: 'Week 6', dateRange: '20-10-2025 to 26-10-2025' },
    { week: 'Week 7', dateRange: '27-10-2025 to 31-10-2025 ' },
];


export default function TermsCondition() {
    const [expanded, setExpanded] = React.useState(""); // Set "panel3" as the default expanded panel

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <div>
        <Box sx={{
                        padding: "0 16px"
                    }}>
                        <Accordion
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid #C1C1C133",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                                color: "#000",
        
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel1" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    color: '#000',
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: '600',
                                    lineHeight: "18px",
        
                                }}
                            >
                                What is CashKaro Dhamaka League?
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: '400',
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                CashKaro Dhamaka League is a limited-time leaderboard contest where registered users compete by accumulating points through specific actions. Points are categorized into weekly and monthly totals, determining user rankings.Top 100 participants weekly and top 10 participants overall will receive Amazon vouchers based on their ranks.
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel2"}
                            onChange={handleChange("panel2")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel2" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Who can participate?
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>The contest is open to registered users of CashKaro only. Participants must explicitly register for the Contest through the dedicated registration page.</li>
                                    <li>Only one entry per person is allowed.</li>
                                </ul>
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel3"}
                            onChange={handleChange("panel3")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1.5px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel3" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Campaign duration
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: '400',
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>The contest is live till 31st October 2025.</li>
                                    <li>The leaderboard is divided into Weekly and Overall rankings. See weeks and their date range in the table below
                                        <TableContainer component={Paper} sx={{ margin: '0' }}>
                                            <Table aria-label="date range table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ border: '1px solid black', fontWeight: 'bold' }}>Week</TableCell>
                                                        <TableCell align="center" sx={{ border: '1px solid black', fontWeight: 'bold' }}>Date range</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {dateData.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center" sx={{ border: '1px solid black' }}>{row.week}</TableCell>
                                                            <TableCell align="center" sx={{ border: '1px solid black' }}>{row.dateRange}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer></li>
                                    <li> Weekly ranking is defined as the rank achieved during a week. Overall ranking is defined as the rank achieved during the entire campaign duration (19-09-2025 to 31-10-2025) </li>
                                </ul>
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel4"}
                            onChange={handleChange("panel4")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel4" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="panel4-content"
                                id="panel4-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                How do I get points?
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <b>There are 7 different ways to get points:</b>
                                <ul>
                                    <li><b>Reach Cashback Goal</b></li>
                                    <ul>
                                        <li>
                                            Each registered user will have 3 distinct Cashback goals.
                                        </li>
                                        <li>Upon achieving the 1st Cashback Goal, users will receive 100 Points along with the Free Money amount associated with that goal. In addition, users can earn 150 and 200 Points respectively, along with the corresponding Free Money amounts, for achieving the 2nd and 3rd Cashback Goals. </li>
                                        <li>Users will earn Points and Free Money for each Cashback Goal achieved; completing all 3 awards the total Points and full Free Money amount mentioned on their Reach Cashback Goal page. </li>
                                        <li>All transactions contributing to the Cashback Goal must be completed within the offer period (till 31st Oct 2025). </li>
                                        <li>This offer does not apply to transactions from Amazon Recharge, Swiggy, or any other stores where Cashback is unavailable.  </li>
                                        <li>
                                            Referral bonuses or any other special bonuses will not be counted towards the user’s Cashback Goal.
                                        </li>
                                        <li>
                                            Once your goal is reached, your Free Money amount will be added to your CashKaro account within 72 hours. It will appear in pending state under the “My Earnings” section.
                                        </li>
                                        <li>
                                            The Free Money amount can be modified or cancelled if the qualifying transactions are returned, canceled, or violates the offer T&C.
                                        </li>
                                        <li>Example: If a user achieved all cashback goals but later cancelled transactions reducing total cashback below the 3rd goal, they will no longer be eligible for the 3rd goal’s Free Money & points, but will receive only what matches their final validated goal.</li>
                                        <li>
                                            The final Free Money amount will be confirmed and credited only after all the transactions contributing to the Cashback Goal are confirmed and validated.
                                        </li>
                                    </ul>
                                    <li><b>Discover Brands</b>
                                        <ul>
                                            <li>Earn 10 points for every unique brand you visit via CashKaro from the list shared.</li>
                                            <li>Get additional 30 points  on visiting at least 5 unique brands</li>
                                            <li>Get additional 60 points if you visit all the 10 brands</li>
                                            <li>Points will be awarded only once for each brand throughout the contest duration. Maximum 190 points will be awarded.</li>
        
        
                                        </ul>
                                        <li><b>Earn points on every shopping via CashKaro</b>
                                            <ul>
                                                <li>For every shopping done on Amazon, Flipkart, AJIO and Myntra via CashKaro get 100 points for each transaction. </li>
                                                <li>
                                                    Apply for any Credit Card via CashKaro and get 400 points once the card is approved and successfully activated.                                     </li>
                                                <li>Shop from anywhere else on CashKaro and get 200 points for every transaction.</li>
                                                <li>
                                                    No points for Swiggy, Recharges, Bill payments, Amazon Pay wallet load & brands with no Cashback. </li>
                                            </ul>
                                            <li><b>Shop from Today's Featured Brand</b>
                                                <ul>
                                                    <li>Shop from the Brand of the Day and earn an additional 300 points.  </li>
                                                    <li>If a user shops more than once from the same brand on a single day, points will be awarded only once.  </li>
                                                </ul>
                                                <li><b>Achieve Milestone Points</b>
                                                    <ul>
                                                        <li>Unlock extra points by reaching specific point milestones.  </li>
                                                        <li>Earn up to 1,000 bonus points for achieving these milestone targets.  </li>
        
                                                    </ul>
                                                    <li><b>Earn points for creating shopping streak</b>
                                                        <ul>
                                                            <li>Shop for 2 days in a row: Get 200 bonus points  </li>
                                                            <li>Shop for 3 days in a row: Get 300 additional bonus points  </li>
                                                            <li>
                                                                Shop for 5 days in a row: Get 500 additional bonus points
                                                            </li>
                                                            <li>If your streak overlaps between two weeks the points will be added to the week in which the streak ends. Example: If you have a streak of 2 days starting on 28th (week 1) and ending on 29th (week 2) then your bonus points for the streak will be added in week 2.</li>
                                                            <li>If you shop for more than 5 days consecutively, your next streak will start from 1 again. Example: If you shop for 7 consecutive days, from 7th to 13th you would have a 5 day streak (from 7th to 11th) and a 2 day streak (from 12th to 13th).</li>
                                                        </ul>
                                                        <li><b>
                                                            Earn bonus points based on your daily spend</b></li>
                                                        <ul>
                                                            <li>Spend ₹5,000 in a day: Earn 100 points</li>
                                                            <li>Spend ₹7,500 in a day: Earn 150 points</li>
                                                            <li>Spend ₹10,000 in a day: Earn 200 points.</li>
                                                            <li>Spends on Swiggy, Amazon pay, recharges, bill payments and any brand with no cashback will not be counted. </li>
                                                            <li>Daily spend will be calculated every day at 11:59 PM. </li>
                                                        </ul>
                                                        <li>
                                                            <b>Date considered </b>
                                                            <ul>
                                                                <li>
                                                                    For all above activities the date for considering points addition would be the Cashback tracked date as shown in the CashKaro application                                                    </li>
                                                            </ul>
                                                        </li>
        
                                                    </li>
                                                </li>
                                            </li>
                                        </li>
                                    </li>                    </ul>
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel5"}
                            onChange={handleChange("panel5")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel5" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="5-content"
                                id="5-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Rewards or Benefits
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li><b>Lucky Draw Prizes:</b> Upon registering for the Contest, participants are automatically entered into a raffle (lucky draw) for a chance to win a Harley Davidson Bike, iPhone 16 128 GB, or a Sony Play Station 5.  </li>
                                    <li><b>Weekly Prizes:</b> Participants with top 100 ranks each week will receive Amazon vouchers based on the following breakdown:  </li>
                                    <ul>
                                        <li>
                                            Ranks 1-10: ₹250 voucher each
                                        </li>
                                        <li>Ranks 11-50: ₹150 voucher each</li>
                                        <li>Ranks 51-100: ₹100 voucher each</li>
                                        {/* <li>
                                        Weeks are determined by below date ranges:
                                        <TableContainer component={Paper} sx={{ margin: '0' }}>
                                            <Table aria-label="date range table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ border: '1px solid black', fontWeight: 'bold' }}>Week</TableCell>
                                                        <TableCell align="center" sx={{ border: '1px solid black', fontWeight: 'bold' }}>Date range</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {dateData.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center" sx={{ border: '1px solid black' }}>{row.week}</TableCell>
                                                            <TableCell align="center" sx={{ border: '1px solid black' }}>{row.dateRange}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </li> */}
                                    </ul>
                                    <li><b>Overall Prizes:</b> Participants with top 10 ranks at the end of the contest will receive Amazon vouchers based on the following breakdown:
                                        <ul>
                                            <li>Ranks 1-3: ₹10,000 voucher each </li>
                                            <li>Ranks 4-6: ₹5,000 voucher each  </li>
                                            <li>Ranks 7-10: ₹2,500 voucher each  </li>
        
                                        </ul>
                                    </li>
                                    Participants will be eligible for lucky draw and overall contest prizes only once. However, they are eligible to compete for weekly prizes every week.                      </ul>
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel6"}
                            onChange={handleChange("panel6")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel6" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="6-content"
                                id="6-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Do I have to register for the contest?
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>Yes, you must be a registered CashKaro user and then register for the Contest via the dedicated offer page.  </li>
                                    <li>Only activities post registration will be considered for points calculation and addition.  </li>
                                    <li>Date for considering points addition would be the cashback tracked date as shown in the CashKaro app.
                                    </li>
                                </ul>
        
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel7"}
                            onChange={handleChange("panel7")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel7" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="7-content"
                                id="7-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Exclusions and Limitations
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>Points can only be earned on brands offering Cashback through the CashKaro app.  </li>
                                    <li>Participants can qualify for weekly Amazon Vouchers multiple times but can win only one of the raffle prizes and one Overall Prize.
                                    </li>
                                </ul>
        
        
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel8"}
                            onChange={handleChange("panel8")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel8" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="8-content"
                                id="8-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                When do you get the prizes?
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>Weekly winners will be announced every Thursday for the previous week and notified via email.  </li>
                                    <li>Overall winners will be announced by 14th November 2025 and communicated to the winners via email.  </li>
                                    <li>Actual voucher distribution will happen by 13th January 2026. Vouchers will be sent to the winners’ email address registered with CashKaro. Requests to send vouchers to any other email address will not be accepted.  </li>
                                    <li>If the Cashback for a transaction is cancelled, the final points and rank will be adjusted accordingly, and the voucher will be issued based on the revised rank.  </li>
                                    <li><b>Raffle (Lucky Draw) Prizes:</b>
                                        <ul>
                                            <li><b>Harley Davidson Bike:</b> The winner must collect the bike in Delhi and will be responsible for paying applicable taxes and covering any transportation costs to their city of residence.  </li>
                                            <li><b>iPhone 16 and Sony PlayStation 5:</b> Prizes will be delivered to the winners’ provided addresses, subject to the serviceability of their PIN code.  </li>
                                            <li>No cash reward will be provided in lieu of the product. If a winner chooses not to accept the product, they will forfeit their claim.
                                            </li>
                                        </ul>
                                    </li>
                                </ul></AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel9"}
                            onChange={handleChange("panel9")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel9" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="9-content"
                                id="9-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Timeline for Fulfilment
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>All weekly and overall vouchers will be distributed by 13th January 2026. </li>
                                    <li>Raffle winners will be announced on 17th December 2025 on CashKaro’s official Instagram page. <a href="https://www.instagram.com/cashkaro" target="_blank">here</a>.</li>
                                    <li>Prizes must be claimed within one week of the announcement; unclaimed prizes will be forfeited.</li>
                                </ul>
        
                            </AccordionDetails>
                        </Accordion>
        
                        <Accordion
                            expanded={expanded === "panel11"}
                            onChange={handleChange("panel11")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel11" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="11-content"
                                id="11-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                When is the leader board updated?
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>The leaderboard is updated daily at 11:00 AM, reflecting tracked transactions and activities from the previous day.  </li>
                                    <li>Rankings are determined by the total points accumulated during the Contest period.  </li>
                                    <li>In case of a tie, the total order value of the transactions will be used as a tiebreaker. If there is still a tie, the total number of transactions will be used as a tiebreaker. </li>
                                    <li>Participants can view both Weekly and Overall leaderboard progress on the contest page.</li>
                                </ul>
        
        
        
                            </AccordionDetails>
                        </Accordion>
        
                        <Accordion
                            expanded={expanded === "panel10"}
                            onChange={handleChange("panel10")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel10" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="10-content"
                                id="10-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Adjustments and termination
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>CashKaro reserves the right to modify or terminate the Contest at any time without prior notice.  </li>
                                    <li>In the event of discrepancies, including transaction cancellations or fraudulent activities, CashKaro reserves the right to adjust scores and rankings.</li>
                                    <li>No upward adjustments in rankings will occur due to another participant's score adjustment; rankings could only decrease.
                                    </li>
                                </ul>
        
        
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expanded === "panel12"}
                            onChange={handleChange("panel12")}
                            sx={{
                                marginBottom: "16px",
                                borderRadius: "14px !important",
                                border: "1px solid rgba(193, 193, 193, 0.20)",
                                background: "rgba(255, 255, 255, 0.10)",
                                backdropFilter: "blur(7px)",
                                boxShadow: "0px 0px 0px 0px !important",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={expanded === "panel12" ? <RemoveIcon sx={{ color: '#000', fontSize: '16px !important' }} /> : <AddIcon sx={{ color: '#000', fontSize: '16px !important' }} />}
                                aria-controls="12-content"
                                id="12-header"
                                sx={{
                                    color: "#000",
                                    fontFamily: "Metropolis ",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                }}
                            >
                                Declaration by user
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    color: "#000",
                                    WebkitTextStrokeWidth: "1",
                                    WebkitTextStrokeColor: "rgba(193, 193, 193, 0.20)",
                                    fontFamily: "Metropolis",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "160%",
                                    letterSpacing: "0.28px",
                                    paddingTop: '0'
                                }}
                            >
                                <ul>
                                    <li>These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of Gurugram, Haryana.  </li>
                                    <li>By participating in the CashKaro Dhamaka League, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.  </li>
                                </ul>
        
        
        
        
                            </AccordionDetails>
                        </Accordion>
                    </Box>
    </div>
    );
}
